'use strict';

var cloudVendors = {
    aws: 'AWS',
    azure: 'AZURE',
    gcp: 'GCP',
    wasabi: 'WASABI'
};

var cloudVendorList = Object.values(cloudVendors);

/**
 * @param {String} vendorType
 * @returns {boolean} - true if the vendor string is a cloud vendor
 */
var isCloudVendor = function isCloudVendor(vendorType) {
    return cloudVendorList.includes(vendorType);
};

module.exports = {
    cloudVendors: cloudVendors,
    cloudVendorList: cloudVendorList,
    isCloudVendor: isCloudVendor
};